import Column from "@amzn/meridian/column";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import React, { ReactNode, useState } from "react";
import { useNotifications } from "../../features/notifications/hooks";
import { saveYourChangesToastMessage } from "../appeals/hooks";

export interface ITabHeader {
    tabs: ITabAttributes[];
}

export interface ITabAttributes {
    label: string;
    value: string;
    content: ReactNode;
}

export const Tabs: React.FC<ITabHeader> = (data: ITabHeader) => {
    const [currentTab, setCurrentTab] = useState("information");

    const { addToast } = useNotifications();
    const handleTabChange = newValue => {
        const blockNavigation = window.history?.state?.blockNavigation;
        if (blockNavigation) {
            addToast(saveYourChangesToastMessage);
        } else {
            setCurrentTab(newValue);
        }
    };

    return (
        <Column width={"fit"}>
            <TabGroup
                fill={"line"}
                value={currentTab}
                onChange={newValue => handleTabChange(newValue)}
                aria-labelledby="tablist-heading"
            >
                {data.tabs.map(({ label, value }) => (
                    <Tab
                        key={value}
                        value={value}
                        aria-controls={`tabpanel-${value.slice(4)}`}
                        id={value}
                    >
                        {label}
                    </Tab>
                ))}
            </TabGroup>
            <Column>
                {data.tabs.map(
                    ({ value, content }) =>
                        currentTab === value && (
                            <div
                                key={value}
                                role="tabpanel"
                                id={`tabpanel-${value.slice(4)}`}
                                aria-labelledby={value}
                            >
                                {content}
                            </div>
                        )
                )}
            </Column>
        </Column>
    );
};
